// import React, { useState } from "react";
// import axios from "axios";
// import api from "../../../../api/axios";

// export default function ReportPageTemplate({ title, desc, reportTypes }) {
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");
//   const [report, setReport] = useState("");
//   const [data, setData] = useState([]);

//   const generateReport = async () => {
//     if (!report) return;

//     const apiUrl = reportTypes.find((r) => r.label === report)?.api;
//     if (!apiUrl) return;

//     try {
//       const response = await api.get(apiUrl, {
//         params: { from, to },
//       });

//       setData(response.data || []);
//     } catch (err) {
//       setData([]);
//     }
//   };

//   return (
//     <div className="container py-4">
//       <h3 className="fw-bold mb-2">{title}</h3>
//       <p className="text-muted">{desc}</p>

//       <div className="card mb-4 shadow-sm">
//         <div className="card-body row gy-3">
//           <div className="col-md-3">
//             <label className="form-label">From Date</label>
//             <input
//               type="date"
//               className="form-control"
//               value={from}
//               onChange={(e) => setFrom(e.target.value)}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">To Date</label>
//             <input
//               type="date"
//               className="form-control"
//               value={to}
//               onChange={(e) => setTo(e.target.value)}
//             />
//           </div>

//           <div className="col-md-4">
//             <label className="form-label">Report Type</label>
//             <select
//               className="form-select"
//               value={report}
//               onChange={(e) => setReport(e.target.value)}
//             >
//               <option>Select Report</option>
//               {reportTypes.map((r, index) => (
//                 <option key={index}>{r.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className="col-md-2 d-flex align-items-end">
//             <button className="btn btn-primary w-100" onClick={generateReport}>
//               Generate
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="card shadow-sm">
//         <div className="card-body">
//           <h5 className="fw-bold mb-3">{title} Data</h5>

//           {data.length === 0 ? (
//             <p className="text-muted">No records found.</p>
//           ) : (
//             <div className="table-responsive">
//               <table className="table table-bordered">
//                 <thead>
//                   <tr>
//                     {Object.keys(data[0]).map((c) => (
//                       <th>{c.toUpperCase()}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, i) => (
//                     <tr key={i}>
//                       {Object.values(row).map((v, j) => (
//                         <td key={j}>{v || "-"}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import api from "../../../../api/axios";

// export default function ReportPageTemplate({ title, desc, reportTypes }) {
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");
//   const [report, setReport] = useState("");
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const isDateValid = from && to && new Date(to) >= new Date(from);
//   const canGenerate = report && isDateValid && !loading;

//   const generateReport = async () => {
//     if (!report || !isDateValid) return;

//     const apiUrl = reportTypes.find((r) => r.label === report)?.api;
//     if (!apiUrl) return;

//     try {
//       setLoading(true);
//       setData([]);
//       const response = await api.get(apiUrl, { params: { from, to } });
//       console.log(response.data);
//       setData(response.data?.data || []);
//     } catch (err) {
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   return (
//     <div className="container py-4">
//       <h3 className="fw-bold mb-2">{title}</h3>
//       <p className="text-muted">{desc}</p>

//       <div className="card mb-4 shadow-sm">
//         <div className="card-body row gy-3">
//           <div className="col-md-3">
//             <label className="form-label">From Date</label>
//             <input
//               type="date"
//               className="form-control"
//               value={from}
//               onChange={(e) => setFrom(e.target.value)}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">To Date</label>
//             <input
//               type="date"
//               className={`form-control ${
//                 to && !isDateValid ? "is-invalid" : ""
//               }`}
//               value={to}
//               onChange={(e) => setTo(e.target.value)}
//             />
//             {!isDateValid && to && (
//               <div className="invalid-feedback">
//                 To date cannot be before From date.
//               </div>
//             )}
//           </div>

//           <div className="col-md-4">
//             <label className="form-label">Report Type</label>
//             <select
//               className="form-select"
//               value={report}
//               onChange={(e) => setReport(e.target.value)}
//             >
//               <option value="">Select Report</option>
//               {reportTypes.map((r, index) => (
//                 <option key={index}>{r.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className="col-md-2 d-flex align-items-end">
//             <button
//               className="btn btn-primary w-100"
//               onClick={generateReport}
//               disabled={!canGenerate}
//             >
//               {loading ? (
//                 <>
//                   <span
//                     className="spinner-border spinner-border-sm me-2"
//                     role="status"
//                     aria-hidden="true"
//                   ></span>
//                   Loading...
//                 </>
//               ) : (
//                 "Generate"
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="card shadow-sm">
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-center mb-3">
//             <h5 className="fw-bold mb-0">{title} Data</h5>
//             {data.length > 0 && (
//               <button
//                 className="btn btn-outline-secondary btn-sm"
//                 onClick={handlePrint}
//               >
//                 🖨️ Print
//               </button>
//             )}
//           </div>

//           {loading ? (
//             <div className="text-center py-5">
//               <div className="spinner-border text-primary" role="status"></div>
//               <p className="mt-2 text-muted">Fetching data...</p>
//             </div>
//           ) : data.length === 0 ? (
//             <p className="text-muted">No records found.</p>
//           ) : (
//             <div className="table-responsive">
//               <table className="table table-bordered">
//                 <thead>
//                   <tr>
//                     {Object.keys(data[0]).map((c, i) => (
//                       <th key={i}>{c.toUpperCase()}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, i) => (
//                     <tr key={i}>
//                       {Object.values(row).map((v, j) => (
//                         <td key={j}>{v || "-"}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import api from "../../../../api/axios";
// import "./report.css";

// export default function ReportPageTemplate({ title, desc, reportTypes }) {
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");
//   const [report, setReport] = useState("");
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const isDateValid = from && to && new Date(to) >= new Date(from);
//   const canGenerate = report && isDateValid && !loading;

//   const generateReport = async () => {
//     if (!report || !isDateValid) return;

//     const apiUrl = reportTypes.find((r) => r.label === report)?.api;
//     if (!apiUrl) return;

//     try {
//       setLoading(true);
//       setData([]);
//       const response = await api.get(apiUrl, { params: { from, to } });
//       setData(response.data?.data || []);
//     } catch {
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** CSV Download **/
//   const handleDownload = () => {
//     if (!data.length) return;

//     const headers = Object.keys(data[0]).join(",");
//     const rows = data
//       .map((row) =>
//         Object.values(row)
//           .map((v) => `"${v ?? ""}"`)
//           .join(",")
//       )
//       .join("\n");

//     const csv = headers + "\n" + rows;

//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${title.replace(/ /g, "_")}_Report.csv`;
//     a.click();
//   };

//   return (
//     <div className="report-container">
//       <h4 className="fw-bold mb-1">{title}</h4>
//       <p className="text-muted mb-3">{desc}</p>

//       {/* FILTER SECTION */}
//       <div className="card mb-3 shadow-sm">
//         <div className="card-body row gy-2">
//           <div className="col-md-3">
//             <label className="form-label small mb-1">From Date</label>
//             <input
//               type="date"
//               className="form-control form-control-sm"
//               value={from}
//               onChange={(e) => setFrom(e.target.value)}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label small mb-1">To Date</label>
//             <input
//               type="date"
//               className={`form-control form-control-sm ${
//                 to && !isDateValid ? "is-invalid" : ""
//               }`}
//               value={to}
//               onChange={(e) => setTo(e.target.value)}
//             />
//             {!isDateValid && to && (
//               <div className="invalid-feedback">
//                 To date cannot be before From date.
//               </div>
//             )}
//           </div>

//           <div className="col-md-4">
//             <label className="form-label small mb-1">Report Type</label>
//             <select
//               className="form-select form-select-sm"
//               value={report}
//               onChange={(e) => setReport(e.target.value)}
//             >
//               <option value="">Select Report</option>
//               {reportTypes.map((r, index) => (
//                 <option key={index}>{r.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className="col-md-2 d-flex align-items-end">
//             <button
//               className="btn btn-primary btn-sm w-100"
//               onClick={generateReport}
//               disabled={!canGenerate}
//             >
//               {loading ? (
//                 <>
//                   <span
//                     className="spinner-border spinner-border-sm me-1"
//                     role="status"
//                   ></span>
//                   Loading...
//                 </>
//               ) : (
//                 "Generate"
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* REPORT DATA */}
//       <div className="card shadow-sm">
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <h6 className="fw-bold mb-0">{title} Data</h6>

//             {data.length > 0 && (
//               <button
//                 className="btn btn-success btn-sm"
//                 onClick={handleDownload}
//               >
//                 ⬇️ Download
//               </button>
//             )}
//           </div>

//           {loading ? (
//             <div className="text-center py-4">
//               <div className="spinner-border text-primary" role="status"></div>
//               <p className="mt-2 text-muted small">Fetching data...</p>
//             </div>
//           ) : data.length === 0 ? (
//             <p className="text-muted small">No records found.</p>
//           ) : (
//             <div className="table-responsive">
//               <table className="table report-table">
//                 <thead>
//                   <tr>
//                     {Object.keys(data[0]).map((c, i) => (
//                       <th key={i}>{c.toUpperCase()}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, i) => (
//                     <tr key={i}>
//                       {Object.values(row).map((v, j) => (
//                         <td key={j}>{v || "-"}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import api from "../../../../api/axios";
import "./report.css"; // IMPORTANT - include the compact CSS

export default function ReportPageTemplate({ title, desc, reportTypes }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [report, setReport] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const isDateValid = from && to && new Date(to) >= new Date(from);
  const canGenerate = report && isDateValid && !loading;

  const generateReport = async () => {
    if (!report || !isDateValid) return;

    const apiUrl = reportTypes.find((r) => r.label === report)?.api;
    if (!apiUrl) return;

    try {
      setLoading(true);
      setData([]);
      const response = await api.get(apiUrl, { params: { from, to } });
      setData(response.data?.data || []);
    } catch {
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // DOWNLOAD CSV
  const handleDownload = () => {
    if (!data.length) return;

    const headers = Object.keys(data[0]).join(",");
    const rows = data
      .map((row) =>
        Object.values(row)
          .map((v) => `"${v ?? ""}"`)
          .join(",")
      )
      .join("\n");

    const csv = headers + "\n" + rows;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${title.replace(/ /g, "_")}_Report.csv`;
    link.click();
  };

  return (
    <div className="report-container">
      {/* FILTER SECTION */}
      <div className="card mb-1 shadow-sm filter-bar-wrapper">
        <div className="card-body filter-bar row gy-1 gx-2">
          <div className="col-md-2">
            <label>From</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label>To</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={to}
              onChange={(e) => setTo(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label>Report Type</label>
            <select
              className="form-select form-select-sm"
              value={report}
              onChange={(e) => setReport(e.target.value)}
            >
              <option value="">Select Report</option>
              {reportTypes.map((r, index) => (
                <option key={index}>{r.label}</option>
              ))}
            </select>
          </div>

          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-primary w-100 btn-sm"
              disabled={!canGenerate}
              onClick={generateReport}
            >
              {loading ? "Loading..." : "Generate"}
            </button>
          </div>

          <div className="col-md-2 d-flex align-items-end">
            {data.length > 0 && (
              <button
                className="btn btn-success w-100 btn-sm"
                onClick={handleDownload}
              >
                Download
              </button>
            )}
          </div>
        </div>
      </div>

      {/* TABLE SECTION */}
      <div className="card shadow-sm">
        <div className="card-body">
          {loading && <p className="text-muted small">Fetching data...</p>}

          {!loading && data.length === 0 && (
            <p className="text-muted small">No records found.</p>
          )}

          {!loading && data.length > 0 && (
            <div className="table-responsive">
              <table className="table report-table">
                <thead>
                  <tr>
                    {Object.keys(data[0]).map((c, i) => (
                      <th key={i}>{c.toUpperCase()}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, i) => (
                    <tr key={i}>
                      {Object.values(row).map((v, j) => (
                        <td key={j}>{v || "-"}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
